import {i18n} from "./i18n";
import {
    app_created,
    app_edit_changed_saved,
    app_edit_deleted,
    app_edit_provider_changed, provider_edit_delete, provider_edit_saved,
    provider_membership_add, provider_membership_rem
} from "./dapiEventUris";
import {setContextActions} from "./contextActions";
import UrlHelpers from "./url";

export class ProviderOverview {
    private _dapi: Dapi = (<any>window).dapi;
    private _dux = (<any>window).dux;
    private _i18n: i18n = new i18n();
    constructor(){
        this._dapi.addResourceEventListener('changed', this._dapi_event);
        this._dapi.addResourceEventListener('deleted', this._dapi_event);
        setContextActions(this._dapi, this._i18n, null);
    }

    private _dapi_event = (resourceEvent: IResourceEvent) => {
        switch (resourceEvent.uri) {
            case provider_edit_delete:
                if(this._dapi.isMainResource()){
                    this._dapi.closeResourceIfMainResource();
                } else {
                    let parentUrl = UrlHelpers.getLinkRelHref('parent');
                    if (parentUrl.isNullOrEmpty()) {
                        console.warn('no parent url found');
                        return
                    }
                    location.href=parentUrl;
                }
                break;
            case app_created:
            case '/center/app/changed':
            case '/center/app/deleted':
            case app_edit_deleted:
            case app_edit_changed_saved:
            case app_edit_provider_changed:
            case provider_membership_add:
            case provider_edit_saved:
                this._page_reload();
        }
        if (resourceEvent.uri.startsWith(provider_membership_rem)) {
            this._page_reload();
        } else if (resourceEvent.uri.indexOf("/f/")!== -1 && resourceEvent.name==='deleted') {
            this._page_reload();
        }
    };

    private _page_reload = () => {
        window.location.reload(true);
    };
}